/* eslint-disable */
import React, { useState, useEffect, Component } from "react";
import { Col, Row, Form, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CustomerModel from "./models/CustomerModel";
import CommentModel from "./models/CommentModel";
import SliModel from "./models/SliModel";
import NavHeader from "./NavHeader";
import LogoComponent from "./LogoComponent";
import ButtonHolder from "./ButtonHolder";
import FinalPageModel from "./models/FinalPageModel";
import { isEmpty, omit } from "lodash";
import {
  saveFormValues,
  nextPage,
  previousPage,
  saveRenderedComponents,
  fetchSendCollectedFeedback,
} from "../Redux/actions";
import LanguageScreen from "components/LanguageScreen";
import DynamicFormItem from "./models/form/DynamicFormItem";
import {
  convertToRGBAString,
  generateRate,
  generateFinalPage,
  orderByPosition,
} from "utils/helperFunctions";
import { fontSize } from "utils/CONSTANTS";
import { BarLoader } from "react-spinners";
import { find, pick } from "lodash";
import { checkIdentification } from "api";
import PageLoader from "./PageLoader";
import { appParamater } from "utils/appDesign";

const Page = () => {
  const [form] = Form.useForm();

  const [renderComponents, setRenderComponents] = useState([]);
  const [identificationLoading, setIdentificationLoading] = useState(false);

  const {
    uid,
    sessions: { [uid]: session },
    user,
    pages,
    widgetJSON: json,
    collectedFeedback: { loading = false },
    currentPage,
    maxPage,
    selectedLanguage,
    pageComponents,
    formValues,
    currentFeedbackScore,
    condition: conditionArray,
    buttonPressed,
    feedbackArray,
    past,
    isFinal,
  } = useSelector((state) => state);
  const condition = useSelector((state) => state.condition);
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentPage > 0) {
      if (buttonPressed === "next_button") {
        const newRenderComponents = getRenderComponents(pageComponents);
        if (newRenderComponents.length > 0) {
          setRenderComponents(newRenderComponents);
          dispatch(saveRenderedComponents(newRenderComponents));
        } else {
          dispatch(saveRenderedComponents([]));
          dispatch(nextPage());
        }
      } else if (buttonPressed === "back_button") {
        const { [currentPage]: page = [] } = past;
        if (page.length > 0) {
          setRenderComponents(page);
        } else {
          dispatch(previousPage());
        }
      }
    }

    return () => {
      setIdentificationLoading(false);
    };
  }, [pageComponents]);

  useEffect(() => {
    if (formValues !== null) {
      form.setFieldsValue({
        ...formValues,
      });
    } else {
      form.resetFields();
    }

    if (currentPage < maxPage) {
      if (pages) {
        const { condition = {} } = pages[currentPage] || {};
        handleIdentification(condition);
      }
    }

    if (currentPage === 1) {
      if (pages[0]) {
        const { languages = [] } = pages[0];
        const language = find(languages, ["lang_code", selectedLanguage]) || {
          ltr: true,
        };
        if (language.ltr) {
          document.documentElement.style.setProperty("--text-align", "left");
          document.documentElement.style.setProperty("--row-align", "row");
        } else {
          document.documentElement.style.setProperty("--text-align", "right");
          document.documentElement.style.setProperty(
            "--row-align",
            "row-reverse"
          );
        }
      }
    }
  }, [currentPage]);

  const handleIdentification = (condition) => {
    if (!isEmpty(condition)) {
      if (
        Array.isArray(condition.identification) &&
        buttonPressed === "next_button"
      ) {
        const reqData = generateIdentificationData({
          identificationArray: condition.identification,
          formValues,
        });
        if (!isEmpty(reqData)) {
          setIdentificationLoading(true);
          checkIdentification(reqData, uid)
            .then((res) => {
              const { data = {} } = res;
              let convertedData = {};
              for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                  if (Array.isArray(data[key])) {
                    convertedData[key] = data[key].map((item) =>
                      item?.id ? item.id : item
                    );
                  } else {
                    if (key === "gender") {
                      convertedData[key] =
                        data[key].charAt(0).toUpperCase() + data[key].slice(1);
                    } else {
                      convertedData[key] = data[key];
                    }
                  }
                }
              }

              form.setFieldsValue({
                customer_data: {
                  ...convertedData,
                },
              });
              setIdentificationLoading(false);
            })
            .catch((err) => {
              console.log(err);
              setIdentificationLoading(false);
            });
        }
      }
    }
  };

  const generateIdentificationData = ({ identificationArray, formValues }) => {
    const reqData = {};
    identificationArray.map((item) => {
      if (formValues.customer_data[item] !== undefined) {
        reqData[item] = formValues.customer_data[item];
      }
    });

    return reqData;
  };

  const submitForm = () => {
    form
      .validateFields()
      .then((values) => {
        if (
          values.customer_data &&
          values.customer_data.phone_number &&
          values.customer_data.phone_number.length < 9
        ) {
          const { customer_data } = values;
          values = {
            ...values,
            customer_data: omit(customer_data, "phone_number"),
          };
        }
        dispatch(saveFormValues(values));
        if (isFinal) {
          dispatch(fetchSendCollectedFeedback());
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const renderComponentByScore = (component) => {
    const ComponentToRender = components[component.componentType];
    const pageCondition = isEmpty(pages[currentPage].condition)
      ? null
      : pages[currentPage].condition;
    const { identification = null, loading } = user;
    if (component.componentType in pages[currentPage]) {
      if (loading) {
        return <div>Loading</div>;
      } else {
        if (component.componentType === "customer_data" && identification) {
          const { status } = identification;
          if (status) {
            return <ComponentToRender data={component} form={form} />;
          }
        } else {
          if (pageCondition && currentFeedbackScore !== null) {
            if (currentFeedbackScore > 0) {
              if (pageCondition.overall.positive[component.componentType]) {
                return <ComponentToRender data={component} form={form} />;
              }
            } else if (currentFeedbackScore < 0) {
              if (pageCondition.overall.negative[component.componentType]) {
                return <ComponentToRender data={component} form={form} />;
              }
            } else if (currentFeedbackScore === 0) {
              if (pageCondition.overall.neutral[component.componentType]) {
                return <ComponentToRender data={component} form={form} />;
              }
            } else {
              return <ComponentToRender data={component} form={form} />;
            }
          } else {
            return <ComponentToRender data={component} form={form} />;
          }

          // if (buttonPressed === 'next_button') {
          //     if (currentPage < maxPage) {
          //         dispatch(nextPage())
          //     }
          // } else if (buttonPressed === 'back_button') {
          //     dispatch(previousPage())
          // }
        }
      }
    }
  };

  const handleRenderByCondition = ({ condition, component }) => {
    const { overall = {} } = condition || {};
    const { identification = null, loading } = user;
    let conditionComponent = null;
    if (component.componentType in pages[currentPage]) {
      if (loading) {
        return <div>Loading</div>;
      } else {
        if (component.componentType === "customer_data" && identification) {
          const { status } = identification;
          if (status) {
            conditionComponent = {
              componentType: component.componentType,
              component,
            };
            // <ComponentToRender data={component} form={form} />
          }
        } else {
          if (conditionArray.length === 0) {
            conditionComponent = {
              componentType: component.componentType,
              component,
            };
          } else {
            const lastCondtion = conditionArray[conditionArray.length - 1];
            Object.keys(lastCondtion).map((key, i) => {
              if (lastCondtion[key]) {
                if (!isEmpty(overall[key])) {
                  const type =
                    component.componentType ===
                    "custom_field_feedback_component"
                      ? "custom_fields"
                      : component.componentType === "sli_data"
                      ? component.idx
                      : component.componentType;
                  if (overall[key][type]) {
                    conditionComponent = {
                      componentType: component.componentType,
                      component,
                    };
                  }
                }
              }
            });
          }
        }
      }
    }

    return conditionComponent;
  };

  const getRenderComponents = (pageComponents) => {
    let componentsToRender = [];
    orderByPosition(pageComponents).map((component) => {
      const prevPage = pages[currentPage > 0 ? currentPage - 1 : 0];
      let { condition = {} } = prevPage || {};
      if (condition.identification !== undefined) {
        condition = omit(condition, ["identification"]);
      }
      // if (isEmpty(condition) || component.componentType === "sli_data") {
      if (isEmpty(condition)) {
        componentsToRender.push({
          componentType: component.componentType,
          component,
        });
      } else {
        const conditionComponent = handleRenderByCondition({
          condition,
          component,
        });
        if (conditionComponent) {
          componentsToRender.push(conditionComponent);
        }
      }
    });

    return componentsToRender;
  };

  let properties = null;

  if (pages) {
    if (currentPage > maxPage) {
      properties = {
        page_bg: pages?.final_page_data?.page_bg,
        page_header: pages.final_page_data?.page_header,
      };
    } else {
      properties = {
        ...pages[currentPage]?.properties,
        page_header: json.data.final_page_data?.page_header,
      };
    }
  }

  const components = {
    customer_data: CustomerModel,
    comment_data: CommentModel,
    custom_field_feedback_component: DynamicFormItem,
    sli_data: SliModel,
    final_page_data: FinalPageModel,
  };

  const getPageBackgroundColor = () => {
    if (currentPage <= maxPage) {
      return convertToRGBAString(properties?.page_bg);
    } else {
      const rate = session?.rate || generateFinalPage({ feedbackArray });
      const { final_page_data = {} } = json.data;
      if (final_page_data.is_all_page_bg) {
        return convertToRGBAString(final_page_data?.page_bg);
      } else {
        return convertToRGBAString(final_page_data[rate]?.page_bg);
      }
    }
  };

  return (
    properties && (
      // <div
      //   style={{
      //     width: "100%",
      //     height: "100%",
      //     position: "absolute",
      //     display: "flex",
      //     flexDirection: "column",
      //   }}
      // >
      //   <Row justify="center">
      //     <Col
      //       xs={24}
      //       md={16}
      //       style={{
      //         backgroundColor: getPageBackgroundColor(),
      //       }}
      //     >
      //       <NavHeader properties={properties} />
      //     </Col>
      //   </Row>
      //   <Row justify="center" style={{ flexGrow: 1 }}>
      //     <Col
      //       xs={24}
      //       md={16}
      //       style={{
      //         height: "100%",
      //         backgroundColor: getPageBackgroundColor(),
      //       }}
      //     >
      //       {pages && pages[currentPage] && pages[currentPage]?.languages ? (

      //         <LanguageScreen page={pages[currentPage]} />
      //       ) : pages && currentPage <= maxPage ? (
      //         <>
      //           {loading || identificationLoading ? (
      //             <PageLoader />
      //           ) : (
      //             <div
      //               style={{
      //                 height: "100%",
      //                 display: "flex",
      //                 flexDirection: "column",
      //                 alignItems: "center",
      //                 // padding: 20,
      //                 paddingTop: pages[currentPage]?.properties.is_page_title
      //                   ? "20px"
      //                   : 0,
      //                 gap: 20,
      //               }}
      //             >
      //               {/* <LogoComponent
      //                 source={json.data.general_settings.logo_url}
      //                 size={json.data.general_settings.logo_size || "M"}
      //               />

      //               {pages[currentPage]?.properties.is_page_title && (
      //                 <span
      //                   className="font-helvetica-neue-medium"
      //                   style={{
      //                     fontSize:
      //                       fontSize[
      //                         pages[currentPage].properties.page_title_size
      //                       ],
      //                     color: convertToRGBAString(
      //                       pages[currentPage].properties.page_title_text_color
      //                     ),
      //                     backgroundColor: convertToRGBAString(
      //                       pages[currentPage].properties.page_title_bg_color
      //                     ),
      //                     borderRadius: 8,
      //                     padding: 10,
      //                   }}
      //                 >
      //                   {
      //                     pages[currentPage].properties.page_title[
      //                       selectedLanguage
      //                     ]
      //                   }
      //                 </span>
      //               )}
      //               */}
      //               <Form
      //                 style={{
      //                   width: "100%",
      //                   flexGrow: 1,
      //                 }}
      //                 form={form}
      //                 layout="vertical"
      //                 scrollToFirstError={true}
      //               >
      //                 <div
      //                   style={{
      //                     display: "flex",
      //                     justifyContent: "center",
      //                     height: "100%",
      //                   }}
      //                 >
      //                   <div
      //                     style={{
      //                       width: "100%",
      //                       display: "flex",
      //                       flexDirection: "column",
      //                       gap: 20,
      //                     }}
      //                   >
      //                     {orderByPosition(renderComponents).map((item) => {
      //                       const ComponentToRender =
      //                         components[item.componentType];
      //                       return (
      //                         <ComponentToRender
      //                           form={form}
      //                           data={item.component}
      //                         />
      //                       );
      //                     })}
      //                     <div
      //                       style={{
      //                         marginTop: "auto",
      //                       }}
      //                     >
      //                       <ButtonHolder onSubmit={submitForm} />
      //                     </div>
      //                   </div>
      //                 </div>
      //               </Form>
      //             </div>
      //           )}
      //         </>
      //       ) : (
      //         <FinalPageModel data={json.data.final_page_data} />
      //       )}
      //     </Col>
      //   </Row>
      // </div>
      <div
        className="container"
        style={{
          backgroundColor: getPageBackgroundColor(),
        }}
      >
        <div
          className="content"
          style={{
            backgroundImage: `url(${appParamater.backgroundImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          {pages && pages[currentPage] && pages[currentPage]?.languages ? (
            <LanguageScreen page={pages[currentPage]} />
          ) : (
            <>
              <div className="header">
                <NavHeader properties={properties} />
              </div>
              {pages && currentPage <= maxPage ? (
                <>
                  {loading || identificationLoading ? (
                    <PageLoader />
                  ) : (
                    <Form
                      form={form}
                      layout="vertical"
                      scrollToFirstError={true}
                      style={{
                        paddingTop: pages[currentPage]?.properties.is_page_title
                          ? "20px"
                          : 0,
                        gap:
                          currentPage === maxPage &&
                          json.data.general_settings.is_enable_policy
                            ? "10px"
                            : "20px",
                      }}
                    >
                      <div className="form-content gap">
                        {orderByPosition(renderComponents).map(
                          (item, index) => {
                            const ComponentToRender =
                              components[item.componentType];
                            return (
                              <ComponentToRender
                                form={form}
                                data={item.component}
                                key={index}
                              />
                            );
                          }
                        )}
                      </div>

                      <div>
                        <div className="footer-button-block">
                          <ButtonHolder onSubmit={submitForm} />
                        </div>
                      </div>
                    </Form>
                  )}
                </>
              ) : (
                <FinalPageModel data={json.data.final_page_data} />
              )}
            </>
          )}
        </div>
      </div>
    )
  );
};

export default Page;
